<template>
    <Banner :id="id"/>
</template>
<script>
import Banner from '@/components/Banner.vue';

export default {
    name: 'BannerAdd',
    components: {
        Banner
    },
    data() {
        return {
            id: null,
        }   
    },
    mounted() {
        this.id = this.$route.params.id ? +this.$route.params.id : null;
    },
}
</script>
